export class DatabaseManagerApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
    public code?: number,
    public errors?: string[],
  ) {
    super(message);
    this.name = 'DatabaseManagerApiError';
  }

  getFullMessage(): string {
    if (!this.errors || this.errors.length === 0) {
      return this.message;
    }

    return `${this.message}: ${this.errors.join(', ')}`;
  }
}

export type FormattedError = {
  message: string;
  details?: string[];
  httpStatus?: number;
  apiCode?: number;
};

function isDatabaseManagerApiError(
  error: unknown,
): error is DatabaseManagerApiError {
  // Duck-typing check - instanceof fails across module boundaries
  return (
    error instanceof Error &&
    error.name === 'DatabaseManagerApiError' &&
    'statusCode' in error
  );
}

export function formatApiError(error: unknown): FormattedError {
  if (isDatabaseManagerApiError(error)) {
    const prefix = error.statusCode ? `HTTP ${error.statusCode}: ` : '';
    const suffix = error.code ? ` (Code ${error.code})` : '';
    return {
      message: `${prefix}${error.message}${suffix}`,
      details: error.errors,
      httpStatus: error.statusCode,
      apiCode: error.code,
    };
  }

  if (error instanceof Error) {
    return { message: error.message };
  }

  return { message: String(error) };
}
